import { MentiError } from '@mentimeter/error-utils/error';
import invert from 'lodash/invert';
import type { QuestionSubType } from '@mentimeter/legacy-series-types/common';
import type { VisualizationSchema as EditorVisualizationSchema } from '../../../compatibility-overrides/editor-types';
// TODO: Move to common constans, since backward compatibility should not depend on forward compatibility
import { QUESTION_SUBTYPE_TO_SLIDE_VISUALIZATION } from '../../../forward-compatibility/converters/question/question-subtype-to-slide-visualization';

const SLIDE_VISUALIZATION_TO_QUESTION_SUBTYPE = invert(
  QUESTION_SUBTYPE_TO_SLIDE_VISUALIZATION,
) as Partial<Record<EditorVisualizationSchema, QuestionSubType>>;

export const visualizationToQuestionSubType = (
  visualization: EditorVisualizationSchema | null,
) => {
  if (!visualization) {
    return null;
  }

  const subType = SLIDE_VISUALIZATION_TO_QUESTION_SUBTYPE[visualization];

  if (!subType) {
    throw new MentiError(
      `slideVisualizationToQuestionSubType: Unknown visualization ${visualization}`,
      { feature: 'compatibility-layer' },
    );
  }

  return subType;
};
